enum ROUTES {
  root = "/order-card",
  token = "/token",
  login = "/login",
  register = "/register",
  passwordRecovery = "/password-recovery",
  setPassword = "/set-password",
  passwordChanged = "/password-changed",
  notFound = "/not-found",
  rateLimit = "/rate-limit-exceeded",
  privacyPolicy = "/privacy-policy",
  termsOfService = "/terms-of-service",
  resetPassword = "/reset-password",
  myAccount = "/my-account",
  loginSuccess = "/login-success",
  filialeDashboard = "/filiale-dashboard"
}

export { ROUTES };
